import { ColDef } from 'ag-grid-community'
import { SortedColumnState } from '../../../../model/bulkSheetColumnSortState'
import { AllState } from '../../../../../store'
import { connect } from 'react-redux'
import { DateTerm } from '../../../../../utils/date'
import { Button } from '../../../../components/buttons'
import { Box, Typography } from '@mui/material'
import { colorPalette } from '../../../../style/colorPalette'
import { intl } from '../../../../../i18n'
import ReloadIcon from '../../../../components/icons/ReloadIcon'
import { MonthRangeSelector } from '../../../../components/headers/HeaderBar/MonthRangeSelector'
import FilterButton from '../../../../containers/BulkSheetView/components/header/FilterButton'
import SortButton from '../../../../containers/BulkSheetView/components/header/SortButton'
import ColumnSettingButton from '../../../../containers/BulkSheetView/components/header/ColumnSettingButton'
import DisplayFormatButton from '../../../../containers/BulkSheetView/components/header/DisplayFormatButton'
import FileExportButton from '../../../../containers/BulkSheetView/components/header/FileExportButton'

export enum ColumnQuickFilterKey {
  INITIAL = 'INITIAL',
  RESTORE = 'RESTORE',
}

interface OwnProps {
  loading: boolean
  dateTerm: DateTerm
  rowHeight: number
  onSearch: (dateTerm: DateTerm) => void
  onSubmit: () => void
  onReload: () => void
  filteredColumns: ColDef[]
  onDeleteFilteredColumn: (column: ColDef) => void
  resetFilters: () => void
  sortColumnState: SortedColumnState[]
  onDeleteSortedColumn: ((column: string | ColDef<any>) => void) | undefined
  onDeleteSortedAllColumns: () => void
  onChangeSortColumnState:
    | ((column: string | ColDef<any>, sort: 'asc' | 'desc' | null) => void)
    | undefined
  columnSettingOpen: boolean
  onClickColumnSettingButton: (e) => void
  onChangeRowHeight: (value: number) => void
  onClickExport: () => void
}

interface StateProps {
  notEdited: boolean
}

type Props = OwnProps & StateProps

const UserPositionsHeader = (props: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: '10px 10px 5px 10px',
        overflowX: 'auto',
        overflowY: 'hidden',
        minHeight: '47px',
      }}
    >
      <Button
        disabled={props.loading || props.notEdited}
        onClick={props.onSubmit}
        colorPattern="green"
        sx={{
          border: 'none',
          cursor: 'pointer',
          padding: '8px 0px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          marginRight: '10px',
        }}
      >
        <Typography
          sx={{ color: colorPalette.monotone[0], margin: '0 2px 0 15px' }}
        >
          {intl.formatMessage({ id: 'wbs.header.save.button' })}
        </Typography>
        <Typography
          sx={{
            color:
              props.loading || props.notEdited
                ? colorPalette.monotone[0]
                : colorPalette.green[2],
            margin: '0 10px 0 2px',
            fontSize: '11px',
          }}
        >
          {intl.formatMessage({ id: 'wbs.header.save.button.shortcutKey' })}
        </Typography>
      </Button>
      <Button
        onClick={props.onReload}
        disabled={props.loading}
        sx={{
          background: colorPalette.monotone[1],
          border: `1px solid ${colorPalette.monotone[3]}`,
          borderRadius: '50%',
          height: '28px',
          width: '28px',
          marginRight: '10px',
          padding: '5px 8px',
          cursor: 'pointer',
          '&:hover': { background: colorPalette.monotone[1] },
        }}
      >
        <ReloadIcon />
      </Button>
      <div>
        <MonthRangeSelector
          dateTerm={props.dateTerm}
          onSearch={props.onSearch}
        />
      </div>
      <FilterButton
        filteredColumns={props.filteredColumns}
        onDeleteFilteredColumn={props.onDeleteFilteredColumn}
        resetFilters={props.resetFilters}
      />
      <SortButton
        sortColumnsState={props.sortColumnState}
        onDeleteSortedColumn={props.onDeleteSortedColumn}
        onDeleteSortedAllColumns={props.onDeleteSortedAllColumns}
        onChangeSortColumnState={props.onChangeSortColumnState}
      />
      <ColumnSettingButton
        open={props.columnSettingOpen}
        onClick={props.onClickColumnSettingButton}
      />
      <DisplayFormatButton
        height={props.rowHeight}
        onChangeHeight={props.onChangeRowHeight}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
        <FileExportButton onClickExport={props.onClickExport} />
      </Box>
    </div>
  )
}

const mapStateToProps = (state: AllState) => ({
  notEdited: !state.hasRequiredSaveData.hasRequiredSaveData,
})

export default connect(mapStateToProps)(UserPositionsHeader)
